import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';

import config from 'lib/config';
import SectionType from 'apps/catalogue/models/SectionType';
import getSectionTitle, { getRibbonForSectionType } from 'apps/fops/utils/getSectionTitle';
import {
  getCatalogueLinkWithoutFilters,
} from 'apps/catalogue/links';

function getLink(title, to, hidden) {
  return (
    <Link
      className={classNames('fop-ribbon__title', {
        'u-hidden': hidden,
      })}
      to={to}
      title={title}
    >
      {title}
    </Link>
  );
}

function getTitle(title, type, cluster, options) {
  const { customAttributes = {}, hidden = false } = options;
  const { campaign } = customAttributes;

  if (
    type === SectionType.CLUSTER
    && cluster.tags
    && cluster.tags[cluster.tags.length - 1].id !== 'other'
  ) { // cluster search ribbon link
    const to = getCatalogueLinkWithoutFilters({
      category: cluster.tags,
    }, '/browse');
    return getLink(title, to, hidden);
  } else if (
    type === SectionType.PERSONALISED_COUPONS
    && campaign
  ) { // coupons ribbon link
    const to = getCatalogueLinkWithoutFilters({
      campaigns: [campaign],
    }, '/coupons/products');
    return getLink(title, to, hidden);
  }

  return (
    <span
      className={classNames('fop-ribbon__title',
        {
          'u-hidden': hidden,
        }
      )}
      title={title}
    >
      {title}
    </span>
  );
}

export default function FopRibbon({
  sectionType, sectionTitle, cluster, customAttributes, idx, sectionLength, hideTitle = false,
}) {
  if (!sectionType) {
    return null; // no type -> no ribbon
  }

  const ribbonTitle = getSectionTitle({ type: sectionType, title: sectionTitle, cluster });
  const ribbonBgCssClass = `fop-ribbon--bg-${getRibbonForSectionType(sectionType).background}`;
  let ribbonPositionCssClass = null;

  if (sectionLength) {
    const positionBeforeEnd = sectionLength - idx - 1;
    if (positionBeforeEnd < 2) { // Add CSS class for the last 2 fops in a section
      ribbonPositionCssClass = `fop-ribbon--n-${positionBeforeEnd}`;
    }
  }

  return (
    <div
      className={classNames(
        'fop-ribbon',
        ribbonBgCssClass,
        ribbonPositionCssClass,
        {
          'fop-ribbon--first': idx === 0,
          'fop-ribbon--repeatTitle': config.fops.repeatRibbonTitle.includes(sectionType),
        }
      )}
    >
      {getTitle(ribbonTitle, sectionType, cluster, {
        customAttributes,
        hidden: config.fops.hideRibbonTitle.includes(sectionType) || hideTitle,
      })}
    </div>
  );
}

FopRibbon.propTypes = {
  sectionType: PropTypes.string,
  sectionTitle: PropTypes.string,
  cluster: PropTypes.object,
  customAttributes: PropTypes.object,
  idx: PropTypes.number.isRequired,
  sectionLength: PropTypes.number,
  hideTitle: PropTypes.bool,
};
